import React from 'react';
import Container from 'react-bootstrap/Container';
import { Row } from 'react-bootstrap';
import Stack from 'react-bootstrap/Stack';
import { getAssessmentContentBlank } from '../shared/report-util';
import { REPORT_TYPE } from '../../../utils/constants';

function StaffingInstructionsPage2({ _remoteStaffing = false }) {
  return (
    <Container className="bg-white mt-2 mb-3 pb-4 candidate-profile-assessments">
      <Container className="m-auto w-75 p-0 pt-5">
        <h4>WORK VALUES FIT</h4>
        <div className="pt-1">
          People tend to be happy and productive in cultures that deliver a work environment aligned to their values,
          and they can be distressed and frustrated working in cultures defined by values that differ from their own.
          The Hutrics Work Values Fit (HWVF) summarizes these work values for each new hire.
        </div>
        <h4 className="pt-4">EXPERIENCE</h4>
        <div className="pt-1">
          The Hutrics Experiences Inventory (HEI) assesses an individual’s knowledge, skill, and experience on several
          key factors such as: Conflict Resolution, Building Relationships, Meeting Facilitation, and Flexibility. New
          hires provide self-report ratings on these key aspects of job performance.
        </div>
        <div className="pt-3 text-bold">Interpreting your scores:</div>
        <div>
          Scores are color-coded to help you easily see where your strengths are and where opportunities can be found.
        </div>
        <Row className="w-100 mx-auto justify-content-center pt-3 pb-3 ps-5">
          <Stack direction="horizontal" className="subscore-chart">
            <div className="w-25">{getAssessmentContentBlank('', 4.25, undefined, REPORT_TYPE.development)}</div>
            <div className="w-75">
              Dark blue bars represent a High score on an assessment (e.g., 65th to 99th % tile).
            </div>
          </Stack>
          <Stack direction="horizontal" className="subscore-chart">
            <div className="w-25">{getAssessmentContentBlank('', 3, undefined, REPORT_TYPE.development)}</div>
            <div className="w-75">
              Teal blue bars represent an Average score on an assessment (e.g., 36th to 64th % tile).
            </div>
          </Stack>
          <Stack direction="horizontal" className="subscore-chart">
            <div className="w-25">{getAssessmentContentBlank('', 2, undefined, REPORT_TYPE.development)}</div>
            <div className="w-75">Sky blue bars represent a Low score on an assessment (e.g., 1st to 35th % tile).</div>
          </Stack>
        </Row>
        <div>
          So, if you have Dark Blue, your new hire’s scores are high on that particular assessment or dimension.
        </div>
      </Container>
    </Container>
  );
}

export default StaffingInstructionsPage2;
